import { useEffect } from "react";

/**
 * Tiny redirect page — takes users hitting a shortcut URL like /etsy or
 * /etsy-strategy (without the .html extension) and pushes them to the real
 * static strategy page at /etsy-strategy.html.
 *
 * Uses window.location.replace so the shortcut URL doesn't clutter history.
 */
export default function EtsyRedirect() {
  useEffect(() => {
    window.location.replace("/etsy-strategy.html");
  }, []);
  return (
    <div style={{ padding: "80px 24px", textAlign: "center", color: "#6b6255", fontFamily: "system-ui, sans-serif" }}>
      Opening the Etsy strategy…
    </div>
  );
}
